import data from '@emoji-mart/data'
import i18n from '@emoji-mart/data/i18n/ru.json'
import { Picker } from 'emoji-mart'
export class EmojiModal {
    constructor(optionalOptions = {}) {
        const modalElm = document.getElementById("modal-emoji-select");

        if (modalElm) {
            new Picker({
                parent: document.querySelector('#modal-emoji-select'),
                data: data,
                i18n: i18n,
                onEmojiSelect: function(emoji) {
                    let emotionSelected = document.querySelector('.tippy-box[data-state="visible"] .chat--chat-message--emotions')
                    if (emotionSelected) {
                        let links = emotionSelected.querySelectorAll('a.chat--chat-message--emotion');
                        let lastLink = links[links.length - 1];
                        let link = lastLink.cloneNode();
                        link.innerHTML = emoji.native;
                        emotionSelected.insertBefore(link, links[links.length - 1].nextSibling);

                        $('#emojiModal').modal("toggle");

                        setTimeout(() => {
                            window.addLinksEmotion();
                        }, 1000);
                    } else {
                        let textareaSelected = document.querySelector('.chat--chat-message--bottom-area .chat--chat-message--bottom-text')
                        if (textareaSelected) {
                            textareaSelected.value += emoji.native;
                            $('#emojiModal').modal("toggle");
                        }
                    }
                },
                dynamicWidth: true,
                navPosition: 'none',
                theme: 'light',
                previewPosition: 'none',
                skinTonePosition: 'none',
                categories: [
                    'people',
                    'symbols',
                    'activity',
                    'flags',
                    'foods',
                    'frequent',
                    'nature',
                    // 'objects',
                    // 'places',
                    //
                ],
            })
        }
    }

    destructor() {
    }
}

export default new EmojiModal();
